import React, { PureComponent } from 'react';

import { Modal, Button } from 'components';

import config from './ModalConfirm.config';
import './ModalConfirm.less';

class ModalConfirm extends PureComponent {
  _renderButton = () => {
    const { btn, onClose } = this.props;

    if (btn.positiveText)
      return (
        <div className="row-submit">
          <Button
            id="btn_negativeModal"
            action={btn.onNegative}
            addClass="outline"
          >
            {btn.negativeText}
          </Button>
          <Button
            id="btn_positiveModal"
            action={btn.onPositive}
            addClass="primary"
          >
            {btn.positiveText}
          </Button>
        </div>
      );

    return (
      <Button id="btn_closeModal" action={onClose} addClass="primary">
        {btn}
      </Button>
    );
  };

  render() {
    const { visible, onClose, title, desc } = this.props;

    return (
      <div className="modal-confirm">
        <Modal visible={visible} onClose={onClose}>
          <div className="title-text">{title}</div>
          <div className="desc-text">{desc}</div>
          {this._renderButton()}
        </Modal>
      </div>
    );
  }
}

ModalConfirm.displayName = config.displayName;
ModalConfirm.defaultProps = config.defaultProps;
ModalConfirm.propTypes = config.propTypes;

export default ModalConfirm;
